/**
 * Step navigation for the child's task flow (TaskMemberModal). Pure, so it is unit-tested.
 * `done[i]` is whether step i is finished (saved or optimistically marked). A result equal to
 * the number of steps means "all done → tidy-up screen".
 */

/** The step to show: the one the child navigated to, otherwise the first unfinished step. */
export function stepToShow(done: boolean[], viewIndex: number | null): number {
  if (viewIndex !== null) return Math.max(0, Math.min(viewIndex, done.length));
  const first = done.findIndex((d) => !d);
  return first === -1 ? done.length : first;
}

/**
 * After "I did it" on step `index`: always the very next step, then tidy-up after the last one.
 * (2026-10-13, found by Jens's son: this used to skip steps already marked done — from an earlier
 * attempt at the same task — so step 3 jumped straight to the end.) Opening a task still resumes
 * at the first unfinished step (stepToShow). `done` is kept in the signature for callers.
 */
export function nextStepIndex(done: boolean[], index: number): number {
  return Math.min(index + 1, done.length);
}

/** "Go back one step" — never before the first step. */
export function previousStepIndex(index: number): number {
  return Math.max(0, index - 1);
}
